module.exports = __webpack_public_path__ + "static/media/007.8658c287.jpg";